import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular/ckeditor.component';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-blog-add',
  templateUrl: './blog-add.component.html',
  styleUrls: ['./blog-add.component.css'],
})
export class BlogAddComponent implements OnInit {
  blogForm: FormGroup;
  private saveApi = environment.url + environment.blogSave;
  private getApi = environment.url + environment.blogGet;
  private deleteApi = environment.url + environment.blogImageDelete;
  /**
   * Component constructor.
   * @param router Angular router service
   * @param fb Angular form builder service
   * @param makeapi API service
   * @param getdata Service that exposes application state
   * @param notify Service that provides toast notifications
   * @param route Angular route service
   */
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    private route: ActivatedRoute
  ) {
    /**
     * Initialize the blog form with default values and validators
     */
    this.blogForm = this.fb.group({
      // Unique identifier for the blog post
      id: [0],
      // Foreign key referencing the incubator
      incubatorId: [''],
      // Short blog description
      blogShortDescription: ['', [Validators.required]],
      // Blog title
      blogName: ['', [Validators.required]],
      // Blog content
      blogContent: ['', [Validators.required]],
      // Blog images
      blogImages: [''],
    });
  }
  get add() {
    return this.blogForm.controls;
  }
  config = {};
  lblName = 'Add';
  savelbl = 'Save';
  /**
   * Initializes the component by setting visibility, checking for query parameters,
   * and updating form values with stored user ID.
   */
  ngOnInit(): void {
    // Set the visibility state to true
    this.getdata.isVisibleSource.next(true);

    // Subscribe to query parameters, filtering by presence of _id
    this.route.queryParams
      .pipe(filter((params) => params._id))
      .subscribe((params) => {
        // Update labels for update operation
        this.lblName = 'Update';
        this.savelbl = 'Update';

        // Decode the _id parameter and fetch blog details
        this.getBlog(atob(params._id));
      });

    // Retrieve current form values
    let getform = this.blogForm.value;

    // Set the incubatorId to the user ID stored in session storage
    getform.incubatorId = sessionStorage.getItem('userId');

    // Update the form with modified values
    this.blogForm.patchValue(getform);
  }
  /**
   * Gets the blog details for the given id and patches the form with the retrieved data.
   * Also updates the image URL and adds the images to the image list.
   * @param _id - The id of the blog to get.
   */
  getBlog(_id: any) {
    this.makeapi
      .method(this.getApi + 'id=' + _id, '', 'get')
      .subscribe((data) => {
        // Patch the form with the retrieved data
        this.blogForm.patchValue(data);

        // If there are images, update the image URL and add them to the image list
        if (data.blogImages.length != 0) {
          // Loop through each image in the list
          data.blogImages.forEach((element) => {
            // Create a request object with the image data
            let req = {
              id: element.id,
              url: element.blogImageName,
              blogImage: element.blogImage,
              blogImageName: element.blogImageName,
            };

            // Add the request object to the image list
            this.mydata.push(req);
          });

          // Update the image URL with the first image in the list
          this.image_url = this.mydata[0].url;
        } else {
          // If there are no images, set the image URL to the default image
          this.image_url = 'assets/images/upload.png';
        }

        // Patch the form with the updated incubatorId
        let getform = this.blogForm.value;
        getform.incubatorId = sessionStorage.getItem('userId');
        this.blogForm.patchValue(getform);
      });
  }
  public Editor = ClassicEditor;
  public onReady(editor: ClassicEditor) {}
  public onChange({ editor }: ChangeEvent) {}
  ImageValue: any = [];
  imgFormat: any;
  selecetdImage: File;
  imagetype: any;
  fileValue: File;
  url1: any = 'assets/images/upload.png';
  img_name = '';
  image_url: any = 'assets/images/upload.png';
  img: any;
  logoCheck = false;
  public files: any[] = [];
  mydata: any = [];

  /**
   * Handles the image selection event, validates each selected image, and adds it to the image list if valid.
   * Displays error notifications for invalid formats or oversized images.
   * @param event - The event triggered when images are selected.
   */
  onSelectImage(event) {
    const files = event.target.files;
    if (files) {
      for (const file of files) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          // Check if the file is an image
          if (file.type.indexOf('image') > -1) {
            // Check if the file size is less than 10MB
            if (file.size < 10485760) {
              // 10MB in bytes
              const splictImg = e.target.result;
              const spl = splictImg.split(',');
              const splType = file.type.split('/');

              // Check if the image format is jpeg, jpg, or png
              if (['jpeg', 'jpg', 'png'].includes(splType[1])) {
                this.img = '';

                const req = {
                  id: 0,
                  url: e.target.result,
                  blogImage: spl[1],
                  blogImageName: file.name,
                };

                // Limit the number of images to 5
                if (this.mydata.length >= 5) {
                  this.notify.notifyError('Maximum 5 Images can be uploaded');
                } else {
                  this.mydata.push(req);
                  this.image_url = this.mydata[0].url;
                }
              } else {
                this.img = 'show';
                this.notify.notifyError(
                  'Only *jpeg, *jpg, *png formats are allowed'
                );
              }
            } else {
              this.notify.notifyError('Maximum 10MB Images can be uploaded');
            }
          }
        };
        reader.readAsDataURL(file);
      }
    }
  }
  /**
   * Deletes an image from the database
   * @param i The index of the image in the mydata array
   * @param id The id of the image in the database
   * @returns none
   */
  deleteImage(i, id) {
    if (id == 0) {
      // if the id is 0, it's a new image
      // remove the image from the mydata array
      this.mydata.splice(i, 1);
      // reset the image_url variable to empty string
      this.image_url = '';
    } else {
      // if the id is not 0, it's an existing image
      // make an API call to delete the image
      return this.makeapi
        .method(this.deleteApi + id, '', 'delete')
        .subscribe((data) => {
          if (data.responseStatus == 'Success') {
            // if the API call is successful, remove the image from the mydata array
            this.mydata.splice(i, 1);
            // show a success notification
            this.notify.notifysuccess(data.responseMessage);
          } else {
            // if the API call fails, show an error notification
            this.notify.notifyError(data.responseMessage);
          }
        });
    }
  }
  /**
   * Saves the blog data into the database
   * @param: none
   * @returns: none
   */
  saveBlog() {
    let getform = this.blogForm.value;
    // checks if the form is invalid or the mydata array is empty
    if (this.mydata.length == 0 || this.blogForm.invalid) {
      // check if the mydata array is empty
      if (this.mydata.length == 0) {
        // set the logoCheck to true
        this.logoCheck = true;
      }
      // mark all form fields as touched
      this.blogForm.markAllAsTouched();
      // show an error message
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      // assign the mydata array to blogImages key
      if (this.mydata.length > 0) {
        getform.blogImages = this.mydata;
      }
      // show the loader
      this.getdata.amizhthLoader('show');
      // make a POST request to the saveApi
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        // hide the loader
        this.getdata.amizhthLoader('hide');
        // check if the responseStatus is Success
        if (data.responseStatus == 'Success') {
          // show a success message
          this.notify.notifysuccess(data.responseMessage);
          // navigate back to the blog list page
          this.cancelBlog();
        } else {
          // show an error message
          this.notify.notifyError(data.responseMessage);
        }
      });
    }
  }
  /**
   * Cancels the blog editing process and navigates back to the blog list page
   */
  cancelBlog() {
    this.router.navigateByUrl('/admin/blog');
  }
}
